import { esgContractStates } from 'shared/constants/esg/esgContractStates';
import { GET_ESG_CONTRACT_DATA_SUCCESS, GET_ESG_CONTRACT_DATA_ERROR } from './esgActions';

const initialState = {
  isPending: true,
  esgRequestPermission: false,
  esgRequestsAllowed: 0,
  esgContractState: esgContractStates.inactive,
};

export function esgContract(state = initialState, action: any) {
  const { payload, type } = action;
  const { esgRequestPermission, esgRequestsAllowed, esgTotalAmount, esgContractState } =
    payload || {};

  switch (type) {
    case GET_ESG_CONTRACT_DATA_SUCCESS:
      return {
        ...state,
        isPending: false,
        esgRequestPermission,
        esgRequestsAllowed,
        esgTotalAmount,
        esgContractState,
      };
    case GET_ESG_CONTRACT_DATA_ERROR:
      return { ...state, isPending: false };
    default:
      return state;
  }
}
